// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"Wr9PZMv9IpZdfbgYRTBq","title":"fsCn7GExGfPYd5NnSxGU"};